import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M16.5 5h-15C.675 5 0 5.675 0 6.5v10c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5v-10c0-.825-.675-1.5-1.5-1.5zm.3 11.5c0 .163-.137.3-.3.3h-15a.304.304 0 0 1-.3-.3v-10c0-.163.137-.3.3-.3h15c.163 0 .3.137.3.3v10zM3 12h2v-2H3v2zm11.8-9.4H3.2A1.2 1.2 0 0 0 2 3.8h14a1.2 1.2 0 0 0-1.2-1.2zm-2-2.6H5.2A1.2 1.2 0 0 0 4 1.2h10A1.2 1.2 0 0 0 12.8 0z" />
  </svg>
);

export default SvgComponent;
